import type { Theme } from "@structurify/shared-types";

interface Props {
  value: number;
  theme: Theme;
  size?: number;
}

export function ConfidenceDot({ value, theme, size = 6 }: Props) {
  const pct = Math.max(0, Math.min(1, value));
  const low = pct < 0.8;
  const r = size;
  const c = 2 * Math.PI * r;
  const dash = c * pct;
  return (
    <svg
      width={size * 2 + 4}
      height={size * 2 + 4}
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      <circle cx={size + 2} cy={size + 2} r={r} fill="none" stroke={theme.rule} strokeWidth="1" />
      <circle
        cx={size + 2}
        cy={size + 2}
        r={r}
        fill="none"
        stroke={low ? theme.confidenceLow : theme.inkSoft}
        strokeWidth="1.25"
        strokeDasharray={`${dash} ${c}`}
        transform={`rotate(-90 ${size + 2} ${size + 2})`}
        style={{ transition: "stroke-dasharray 600ms cubic-bezier(.2,.7,.2,1)" }}
      />
    </svg>
  );
}
